/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Group, Copy, Title, BodyCopy, CTAs, Button, Form, Grid, GridSet, GridItem, TextField } from '@insticator/insticator-ui'; // iui-material
import SignUpCTA from 'material/ctas/signup/signup';
// styles
import injectSheet from 'react-jss';
import styles from './resetpassword_styles'
// import styles from 'pages/auth/requestdemo/requestdemo_styles';



/* ========== ~~~~~~~~~~ AUTH RESET PASSWORD ~~~~~~~~~~ ========== */
class ResetPasswordPage extends Component {
    constructor(props){
        super(props);
        this.formName = 'resetpassword';
    }

    handleResetPassword = () =>{
        this.props.resetPassword(this.props.fields, this.getFormCallData(), this.handleSucessReset, this.handleFailedReset);
    };

    handleSucessReset = ()=>{
        this.props.moveToPage('auth/passwordreset');
        const successMessage = 'Password reset link sent';
        this.props.displaySuccessMessage(successMessage);
    };

    handleFailedReset = ()=>{
        this.props.displayErrorMessage('Woops, something wrong: Network error. Please try again later.')
    };
    handleKeyPress = e => {
        if(e.keyCode === 13){
            this.handleSignIn()
        }
    };
    getFormCallData = () =>({
        email: this.props.fields.email.value
    });

    render() {
        return(
            <Page name={`resetpassword`} klass={this.props.classes.resetpassword}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <h2>Reset Password</h2>
                        </Title>
                        <BodyCopy>
                            <p>Enter the email address associated with your account, and we'll email you a link to reset your password.</p>
                        </BodyCopy>
                    </Copy>
                    <Form name={this.formName} editable={!this.props.savingData}>
                        <Grid type={`fields`}>
                            <GridSet direction={`vertical`}>
                                <GridItem><TextField type={`email`} name={`email`} value={this.props.fields.email.value} valid={this.props.fields.email.valid} formName={this.formName} placeholder={`Email`} label={`Email Address`} info={``} onKeyDown={this.handleKeyPress} required /></GridItem>
                            </GridSet>
                        </Grid>
                        <CTAs>
                            <Button type={'action'} action={this.handleResetPassword} variant={`primary`} name={`sendreset`} processing={this.props.savingData} operation={'load'} disabled={this.props.savingData} text={`Send reset link`} />
                        </CTAs>
                    </Form>
                </Group>
                <Group name={`callout`}>
                    <SignUpCTA />
                </Group>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ResetPasswordPage);
